import { render, staticRenderFns } from "./CustomerActionMassDelete.vue?vue&type=template&id=03f7f652&"
import script from "./CustomerActionMassDelete.vue?vue&type=script&lang=ts&"
export * from "./CustomerActionMassDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports